import RestorePage from './RestorePage';

export default RestorePage;
